import React from 'react';
import { ChatIcon } from "@assets/icons";
import css from "./EnquiryForm.module.scss";

export default function EnquiryFormHeader({ supplierName, isSupplierMessaging }: { supplierName: string, isSupplierMessaging: boolean }) {
    return (
        <div className={css.header}>
            <div className={css.firstline}>{isSupplierMessaging ? 'SEND A MESSAGE TO' : 'ENQUIRE WITH'}</div>
            <div className={css.supplier}>{supplierName}</div>
            <div className={css.secondline}>
                {isSupplierMessaging && <ChatIcon />}
                Typically responds within 24h
            </div>
        </div>
    )
};
